import _ from 'lodash';

const dateDiffInDays = (a, b) => {
  // a - b
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc1 - utc2) / _MS_PER_DAY);
};

export const reducer = (previousState = initialState, action) => {
  switch (action.type) {
    case 'SET_STEP':
      return {
        ...previousState,
        step: action.stepNum,
      };
    case 'SET_FORM_DATA':
      const tempState = {
        ...previousState,
        formData: {
          ...previousState.formData,
          ...action.hash,
        },
      };

      if (tempState.formData.ownerAddressSameAsProperty === 'true') {
        tempState.formData.ownerAddress = tempState.formData.propertyAddress;
      }
      if (action.hash.ownerAddressSameAsProperty === 'false') {
        tempState.formData.ownerAddress = {};
      }

      if (
        tempState.formData.userPreferredContact === 'email' &&
        !tempState.formData.preferredContactMethods.includes('email')
      ) {
        tempState.formData.preferredContactMethods.push('email');
      } else if (!tempState.formData.emailPreferred) {
        tempState.formData.preferredContactMethods = tempState.formData.preferredContactMethods.filter(
          e => e !== 'email'
        );
      }

      if (
        tempState.formData.userPreferredContact === 'phone' &&
        !tempState.formData.preferredContactMethods.includes('phone')
      ) {
        tempState.formData.preferredContactMethods.push('phone');
      } else if (!tempState.formData.phonePreferred) {
        tempState.formData.preferredContactMethods = tempState.formData.preferredContactMethods.filter(
          e => e !== 'phone'
        );
      }

      if (
        tempState.formData.closeDateMonth &&
        tempState.formData.closeDateDay &&
        tempState.formData.closeDateYear &&
        tempState.formData.closeDateYear.length == 4
      ) {
        const closedOnDate = new Date(
          tempState.formData.closeDateYear,
          tempState.formData.closeDateMonth - 1,
          tempState.formData.closeDateDay
        );
        const currentDate = new Date();

        tempState.notClosedYet = dateDiffInDays(currentDate, closedOnDate) < 0;
        tempState.overSixtyDays = dateDiffInDays(currentDate, closedOnDate) > 60;
      } else {
        tempState.notClosedYet = false;
        tempState.overSixtyDays = false;
      }
      return tempState;
    case 'SHOW_MODAL':
      return {
        ...previousState,
        showModal: action.showModal,
      };
    case 'SET_OVER_SIXTY':
      return {
        ...previousState,
        overSixtyDays: action.overSixtyDays,
      };
    case 'SET_NOT_CLOSED':
      return {
        ...previousState,
        notClosedYet: action.notClosedYet,
      };
    case 'SET_APP_DATA':
      return {
        ...previousState,
        appData: {
          ...previousState.appData,
          ...action.hash,
        },
      };
    default:
      return previousState;
  }
};
